import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorCodeService {
  private readonly codes$ = new BehaviorSubject<ErrorCodesEnum>(
    ErrorCodesEnum.No
  );

  public getCodes(): Observable<ErrorCodesEnum> {
    return this.codes$.asObservable();
  }

  public getCurrentCode(): ErrorCodesEnum {
    return this.codes$.value;
  }

  public pushCode(code: ErrorCodesEnum): void {
    this.codes$.next(code);
  }
}
